export const adminAuthenticated = `
  query AdminAuthenticated {
    adminAuthenticated
    adminEmail
  }
`;
